import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUpIcon } from 'lucide-react';
interface BackToTopProps {
  position?: 'left' | 'right';
}
export function BackToTop({
  position = 'right'
}: BackToTopProps) {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-747" data-mp="320goma8rjmsd">
      {isVisible && <motion.button initial={{
      opacity: 0,
      scale: 0.8
    }} animate={{
      opacity: 1,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: 0.8
    }} transition={{
      duration: 0.2
    }} onClick={scrollToTop} className={`fixed bottom-8 ${position === 'left' ? 'left-8' : 'right-8'} z-50 flex h-12 w-12 items-center justify-center rounded-full bg-sand-300 text-ink-900 shadow-lg transition-colors hover:bg-sand-400`} aria-label="Back to top" data-id="element-748" data-mp="3azrvlefa0ge">
          <ArrowUpIcon size={20} strokeWidth={2} data-id="element-749" data-mp="3sbkjd04048d0" />
        </motion.button>}
    </AnimatePresence>;
}